/**
 * Defines a frontend value used by the ui metrics feature: .
 */
type YandexMetrikaFunction = {
  (...parameters: unknown[]): void;
  a?: unknown[][];
  l?: number;
};

/**
 * Defines a frontend value used by the ui metrics feature: global.
 */
declare global {
  interface Window {
    ym?: YandexMetrikaFunction;
  }
}

/**
 * Defines a frontend value used by the ui metrics feature: counter id.
 */
const counterId = 105912416;
/**
 * Defines a frontend value used by the ui metrics feature: tag url.
 */
const tagUrl = `https://mc.yandex.ru/metrika/tag.js?id=${counterId}`;
/**
 * Defines a frontend value used by the ui metrics feature: script type.
 */
const scriptType = 'script';
/**
 * Defines a frontend value used by the ui metrics feature: metrika function name.
 */
const metrikaFunctionName = 'ym';

/**
 * Executes the initialize yandex metrika step of the ui metrics frontend scenario.
 * @returns Nothing; applies the change to page state, DOM, or an external UI runtime.
 */
function initializeYandexMetrika(): void {
  window[metrikaFunctionName] =
    window[metrikaFunctionName] ||
    function (...parameters: unknown[]): void {
      const metrikaFunction = window[metrikaFunctionName] as YandexMetrikaFunction;

      metrikaFunction.a = metrikaFunction.a || [];
      metrikaFunction.a.push(parameters);
    };

  window[metrikaFunctionName].l = Date.now();

  let isTagScriptLoaded = false;

  for (const script of document.scripts) {
    if (script.src === tagUrl) {
      isTagScriptLoaded = true;
      break;
    }
  }

  if (!isTagScriptLoaded) {
    const metrikaScriptElement = document.createElement(scriptType);
    const firstScriptElement = document.getElementsByTagName(scriptType)[0];

    metrikaScriptElement.async = true;
    metrikaScriptElement.src = tagUrl;
    firstScriptElement.parentNode?.insertBefore(metrikaScriptElement, firstScriptElement);
  }

  window.ym?.(counterId, 'init', {
    ssr: true,
    webvisor: true,
    clickmap: true,
    ecommerce: 'dataLayer',
    accurateTrackBounce: true,
    trackLinks: true,
  });
}

initializeYandexMetrika();

export type { YandexMetrikaFunction };
